import { useState, useEffect, useCallback } from 'react';
import API from '@/lib/api';
import { toast } from 'sonner';

export function useTasks(params = {}) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params);

  const load = useCallback(async () => {
    try { setTasks((await API.get('/tasks', { params: JSON.parse(key) })).data); }
    catch { toast.error('Failed to load tasks'); }
    finally { setLoading(false); }
  }, [key]);

  useEffect(() => { load(); }, [load]);

  const toggle = async (t) => {
    setTasks(prev => prev.map(x => x.id === t.id ? { ...x, done: !t.done } : x));
    try { await API.put(`/tasks/${t.id}`, { done: !t.done }); if (!t.done) toast.success('Task done'); window.dispatchEvent(new Event('tasks-changed')); }
    catch { toast.error('Failed to update'); load(); }
  };

  const remove = async (t) => {
    if (!window.confirm('Delete this task?')) return;
    await API.delete(`/tasks/${t.id}`);
    setTasks(prev => prev.filter(x => x.id !== t.id));
    window.dispatchEvent(new Event('tasks-changed'));
  };

  const snooze = async (t) => {
    const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0);
    const due_at = d.toISOString();
    setTasks(prev => prev.map(x => x.id === t.id ? { ...x, due_at } : x));
    try { await API.put(`/tasks/${t.id}`, { due_at }); toast.success('Snoozed to tomorrow 9:00 AM'); window.dispatchEvent(new Event('tasks-changed')); }
    catch { toast.error('Failed to snooze'); load(); }
  };

  const reload = () => { load(); window.dispatchEvent(new Event('tasks-changed')); };

  return { tasks, loading, reload, toggle, remove, snooze };
}
